import React, { Component } from 'react';
import Header from '../../Layout/Header'
import { Link } from 'react-router-dom'
// import Sidebar from '../Blog/Sidebar'

class AppDevelopment extends Component {
	render() {
		return (
<div>
				<Header
					seoTitle="App Development"
					title={"app develpment"}
					image={require('./image-3.jpg')}
				/>
				<div className="entry-content page-blog">


				<div className="container-fluid">
                       			<h2 className="outline text-center">
                            			<div className="line"></div>
                            			<div className="title">
                               			   <img
                                    			src={require("./moshi-icon.png")}
                                    			alt="Icon"
                                    			width="48"
                                    			style={{
                                    			marginTop: -18,
                                    			marginBottom: -12,
                                    			marginRight: 12
                                		   }}/>
                               			 App Development
                            			</div>
                       			 </h2>
                    		</div>

					
					<div className="container">
						
						<div className="row">
							<div className="col-lg-12">
							
							

								<p>Most of the time, businesses have to wait for their customers to come to them - do you want to turn the tables? Apps are a great way to both connect with and prompt action from your customers. Our team at Moshi Moshi will work with you to create a solid business idea for your app, with your goal and end user in mind.  </p>

								<h4>Before development even starts, we begin by asking the most important questions:</h4>
								
        <ul class="with-icons">
              <li>What is the aim of your app?</li>
              <li>What problem is it solving?

</li>
              <li>Who are you targeting? Are you imagining it just for Android or iOS users? Staff or the general public?</li>
<li>What's your budget?</li>


        </ul>
    <p>Once we have these answers, our team can begin brainstorming the content, design, layout and development with you. We have developed a range of apps for local businesses in the South West, including the Prince of Wales Hotel in Bunbury, to showcase upcoming gigs and shows and to prompt their customers to come along using push notifications. 

</p>
<p>Our apps are quick to load, easy to use, visually appealing and modern. 
</p>
<h1></h1>
<br></br>
<a href="https://www.moshi.com.au/what-weve-done/prince-hotel"><img src={require('./Prince-example.png')} style={{padding: 30}} height="375" width="350" alt="Prince of Wales App" className="align-centre" align="centre" /></a>

<a href="https://www.businessnews.com.au/topic/covid-19"><img src={require('./Business-News.png')} style={{padding: 30}} height="375" width="350" alt="Business News COVID 19 app" className="align-centre" align="centre" /></a>

<a href="https://www.moshi.com.au/what-weve-done/cciwa-wa-works"><img src={require('./WAWorks-example.png')} style={{padding: 30}}  height="375" width="350" alt="WA Works app" className="align-centre" align="centre" /></a>



<br></br>
<hr></hr>
<h2>Related Services</h2>

<a class="btn" href="https://www.moshi.com.au/whatwedo/website-development">Website Development</a> 		
<a class="btn" href="https://www.moshi.com.au/whatwedo/custom-programmed-systems">Custom Programmed Systems</a>	
<a class="btn" href="https://www.moshi.com.au/whatwedo/ecommerce-and-online-shops">Ecommerce and Online Shops</a>
		
<a class="btn" href="https://www.moshi.com.au/whatwedo/photography-and-video-shoots">Photography and Video Shoots</a>		
<a class="btn" href="https://www.moshi.com.au/whatwedo/graphic-design">Graphic Design</a>		
<a class="btn" href="https://www.moshi.com.au/whatwedo/website-hosting">Website Hosting</a>


	


						
							</div>
							{/* <div className="col-lg-4">
								<Sidebar />
							</div> */}
						</div>
<hr></hr><br></br>
<h3>If you have a plan for a web app, native mobile app, pc app, business app, customer app or cloud app, get in touch with the Moshi Moshi team and we’ll get you on your way!</h3>


					</div>
				</div>

			</div>
		);
	}
}

export default AppDevelopment;


// WEBPACK FOOTER //
// ./src/Pages/WhatWeDo/AppDevelopment.js